
<p-panelMenu *ngIf="app?.menuMode!='horizontal'" [model]="items" [multiple]="false" [style]="{'width':'auto','background-color':'transparent'}" tooltipEvent="focus">
</p-panelMenu>
<ul class="layout-menu" *ngIf="app?.menuMode === 'horizontal'">
  <li
    app-menuitem
    *ngFor="let item of items; let i = index"
    [item]="item"
    [index]="i"
    [root]="true"
    (click)="activeIndex = i"
    [class.active]="activeIndex === i">
  </li>
</ul>



<p-dialog
  [(visible)]="fullPageDialog"
  [modal]="true"
  [dismissableMask]="false"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [baseZIndex]="10000"
  [style]="{ width: '100vw', height: '100vh', margin: '0', padding: '0' }"
  styleClass="full-page-dialog no-shadow"
>
  <section class="dots-container">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </section>
</p-dialog>
